import baseUrl from '../baseUrl'
export default {
  getOrder: baseUrl + '/v1/order/index',
  stuLoginDevice: baseUrl + '/v1/device/device-practice-login-status',
  stuPracticeDriving: baseUrl + '/v1/device/device-practice-status',
  stuDeviceList: baseUrl + '/v1/device/device-practice-list',
  stuTimerProduct: baseUrl + '/v1/order/product',
  stuTimerPay: baseUrl + '/v1/order/pay',
}
